import { css } from '@emotion/react';
import type { DimensionType } from './Text';

export const container = css`
  position: relative;
`;

export const makeUp = (params: {
  bold?: boolean;
  leading?: DimensionType;
  size?: DimensionType;
}) => {
  const { bold, leading, size } = params;
  return css`
    font-size: var(--text-${size});
    line-height: var(--leading-${leading});
      ${!!bold &&
      css`
        font-weight: 600;
      `};
  `;
};
